import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter, { rankings } from 'match-sorter';
import SubComponent from './SubComponentBuilder';
import CellBuilder from './CellBuilder';
import RomanianPackage from '../languages/RomanianPackage';
import HeaderHide from '../tableHeaderExceptions/TableHeaderHide';
import {connect} from 'react-redux';

class TableBuilder extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            expanded: {}
        }

        this.renderColumns = this.renderColumns.bind(this);
        this.renderSubComponents = this.renderSubComponents.bind(this);

    }

    renderColumns(columns) {

        var cols = columns.map(col => ({
            'Header': col.Name,
            'accessor': col.Name,
            'type': col.Type,
            'editable': col.Editable,
            show: HeaderHide.includes(col.Name) ? false: true,
            filterMethod: (filter, rows) => {
                return matchSorter(rows, filter.value, { threshold: rankings.CONTAINS, keys: [col.Name] })
            },
            Cell: (cellInfo) => {
                return (
                    <CellBuilder
                        column = {cellInfo.column.id}
                        index = {cellInfo.index}
                        data = {this.props.data}
                        type = {cellInfo.column.type}
                        editable = {cellInfo.column.editable}
                        isSubComponent = {false}
                    />
                );
            }
            ,
            filterAll: true,
        }
        ));

        return (cols);
    }

    renderSubComponents(row) {
        return (
            <SubComponent
                rowData={row.row.Nr_Crt}
                phpFile={this.props.phpSubFile}
            />
        );

    }

    handleRowExpanded(newExpanded, index, event) {
        this.setState({
            expanded: {[index[0]]: !this.state.expanded[index[0]]}
        });
    }

    render() {

        if (this.props.columns.length !== 0 ) {

            return (
                <div>
                    <ReactTable
                        data={this.props.data}
                        filterable
                        columns={
                            this.renderColumns(this.props.columns)
                        }
                        defaultPageSize={10}
                        className="-striped -highlight"
                        SubComponent={this.props.view.phpSubtype ? row => {
                            return (
                                this.renderSubComponents(row)
                            )
                        }: null}
                        expanded={this.state.expanded}
                        onExpandedChange={(newExpanded, index, event) => this.handleRowExpanded(newExpanded, index, event)}
                        previousText= {RomanianPackage.PREVIOUS_TEXT}
                        nextText= {RomanianPackage.NEXT_TEXT}
                        loadingText= {RomanianPackage.LOADING_TEXT}
                        noDataText= {RomanianPackage.NO_DATA_TEXT}
                        pageText= {RomanianPackage.PAGE_TEXT}
                        ofText= {RomanianPackage.OF_TEXT}
                        rowsText= {RomanianPackage.ROWS_TEXT}
                    />
                    <div id='test'></div>
                </div>
            )
        }
        else {
            
            return(
                <div />
            )
        }
    }
}

function mapStateToProps(state) {

    return {
        columns: state.activeOption.tableHeader,
        data: state.table.data,
        view: state.activeOption
    }
}

export default connect(mapStateToProps)(TableBuilder);


// WEBPACK FOOTER //
// ./src/tableBuilder/TableBuilder.js